// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail {
    border: 1px solid black;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 10px;
}

.sideNavTree {
    flex: 1 1 auto;
    width: 18em;
    margin-right: 10px;
    overflow: hidden;
}


`, "",{"version":3,"sources":["webpack://./src/app/settings/roles/permissions/permissions.page.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".detail {\n    border: 1px solid black;\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    padding: 10px;\n}\n\n.sideNavTree {\n    flex: 1 1 auto;\n    width: 18em;\n    margin-right: 10px;\n    overflow: hidden;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
